import { render, staticRenderFns } from "./RecentHospitalization.vue?vue&type=template&id=ef5a470a&"
import script from "./RecentHospitalization.vue?vue&type=script&lang=js&"
export * from "./RecentHospitalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports